import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from "environments";
import { Observable } from 'rxjs';
import Utils from '../../../../../../angularJs/src/app/services/utils.service';
import {
  GpAddressApiJsonUpdateAddress,
  GpAddressApiJsonUpdateAddressAttribute,
  GpAddressResponse,
  QueryParams,
} from '../../../../types/gp-address-request-response';

enum EnumGpAddressEndpoints {
  GET_ALL_ADDRESSES = 'admin/orders/gpaddresses/',
  GET_PENDING_GPLETTERS = `admin/orders/pendinggpletters/`,
  GET_PRINTABLE_GPLETTERS = `admin/orders/print-gp-letters`,
  UPDATE_ADDRESS_GPADDRESSES = `gpaddresses/`,
  GENERATE_PDF_GPLETTERS = 'admin/orders/gpletters/generatepdf/',
  MARKS_PRINTED_GPLETTERS = 'admin/orders/markasprinted',
}

@Injectable({
  providedIn: 'root',
})
export class GpAddressesApiService {
  // injections
	private env = inject<PIMSEnvironment>(ENVIRONMENT)
  private http = inject(HttpClient);
  private Utils = inject(Utils);

  getAddresses(queryParams: QueryParams): Observable<GpAddressResponse> {
    const query = this.Utils.buildJsonApiParams(queryParams);
    return this.http.get<GpAddressResponse>(
      `${this.env.constants.ADMIN_API_URL}/${EnumGpAddressEndpoints.GET_ALL_ADDRESSES}${query}`,
    );
  }

  getPendingGpLetters(queryParams: QueryParams): Observable<GpAddressResponse> {
    const query = this.Utils.buildJsonApiParams(queryParams);
    return this.http.get<GpAddressResponse>(
      `${this.env.constants.ADMIN_API_URL}/${EnumGpAddressEndpoints.GET_PENDING_GPLETTERS}${query}`,
    );
  }

  putUpdateAddresses$(
    id: string,
    address: GpAddressApiJsonUpdateAddressAttribute,
  ): Observable<GpAddressApiJsonUpdateAddress> {
    return this.http.put<GpAddressApiJsonUpdateAddress>(
      `${this.env.constants.ADMIN_API_URL}/${EnumGpAddressEndpoints.UPDATE_ADDRESS_GPADDRESSES}${id}`,
      {
        data: {
          type: 'gpaddresses',
          attributes: {
            ...address,
          },
        },
      },
    );
  }

  postPrintLetters$(visitIdList: string[]): Observable<Blob> {
    return this.http.post(
      `${this.env.constants.ADMIN_API_URL}/${EnumGpAddressEndpoints.GENERATE_PDF_GPLETTERS}`,
      {
        orders: visitIdList,
      },
      { responseType: 'blob' },
    );
  }

  // putMarkAsPrinted() Response is 204 no content ok gpletter was markes as printed
  putMarkAsPrinted$(visitIds: string[]): Observable<unknown> {
    return this.http.put(`${this.env.constants.ADMIN_API_URL}/${EnumGpAddressEndpoints.MARKS_PRINTED_GPLETTERS}`, {
      orders: visitIds,
    });
  }
}
